"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DocUploader_1 = require("Dashboard/DocUploader/DocUploader");
var Telemetry_1 = require("Telemetry");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var NewEditorModal_1 = __importDefault(require("./NewEditorModal"));
var DashboardTelemetry_1 = require("./DashboardTelemetry");
var MobileSharePopoverModal_1 = require("./MobileSharePopoverModal/MobileSharePopoverModal");
var TagModal_1 = require("./TagModal/TagModal");
var UseOpenProjectAnalytics_1 = require("Analytics/Page/UseOpenProjectAnalytics");
var DashboardController = (function () {
    function DashboardController(projectLimit, projectLiveLimit, upseller, projectService, $state, goToProjectAction, usingFeature, isMobile, modal, permissionsService, openBrandSetup, initSubscription, trial, publicApiBaseUrl, rootDataStore, telemetry, serverTelemetry, uploadStore, apiBaseUrl, viewBluePrintChildren, projectAuditInspector) {
        var _this = this;
        this.projectLimit = projectLimit;
        this.projectLiveLimit = projectLiveLimit;
        this.upseller = upseller;
        this.projectService = projectService;
        this.$state = $state;
        this.goToProjectAction = goToProjectAction;
        this.usingFeature = usingFeature;
        this.isMobile = isMobile;
        this.modal = modal;
        this.permissionsService = permissionsService;
        this.openBrandSetup = openBrandSetup;
        this.initSubscription = initSubscription;
        this.trial = trial;
        this.publicApiBaseUrl = publicApiBaseUrl;
        this.rootDataStore = rootDataStore;
        this.telemetry = telemetry;
        this.uploadStore = uploadStore;
        this.apiBaseUrl = apiBaseUrl;
        this.viewBluePrintChildren = viewBluePrintChildren;
        this.projectAuditInspector = projectAuditInspector;
        this.isUsingFeature = function (featureFlag) {
            return _this.usingFeature(featureFlag);
        };
        this.uploadDocFile = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, DocUploader_1.createDocConversionModal)(this.uploadStore, this.projectService, this.apiBaseUrl, this.modal)];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.createNewProject = function (parentFolderId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.projectLimit.hasHitLimit() || this.projectLiveLimit.hasHitLimit())) return [3, 1];
                        return [2, this.upseller.upsell({
                                showProjectUpsell: true,
                            })];
                    case 1: return [4, this.projectService.create(parentFolderId)];
                    case 2: return [2, _a.sent()];
                }
            });
        }); };
        this.goToTemplate = function (templateId, params) {
            _this.$state.go("project", __assign({ id: templateId }, params));
        };
        this.goToTemplates = function () {
            if (_this.projectLimit.hasHitLimit() || _this.projectLiveLimit.hasHitLimit()) {
                return _this.upseller.upsell({
                    showProjectUpsell: true,
                });
            }
            else {
                if (_this.usingFeature(FeatureFlag_1.FeatureFlag.TemplateEssentialsCreator)) {
                    _this.$state.go("templatesGallery");
                }
                else {
                    _this.$state.go("templateselection");
                }
            }
        };
        this.openProjectAnalytics = function (projectStore, eventOrigin) {
            _this.openProjectAnalyticsFunction(projectStore, eventOrigin);
        };
        this.openProject = function (projectStore, origin) { return __awaiter(_this, void 0, Promise, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (projectStore.usingNewEditor && this.usingFeature(FeatureFlag_1.FeatureFlag.OptOutNewEditor)) {
                            this.triggerNewEditorModal();
                            return [2];
                        }
                        if (!this.isMobile()) return [3, 2];
                        return [4, projectStore.getCollaboratorPageUrlWithGeneration({ source: TelemetryEnums_1.TelemetrySource.Dashboard })];
                    case 1:
                        url = _a.sent();
                        window.open(url);
                        return [2];
                    case 2:
                        this.projectService.open(projectStore, origin);
                        return [2];
                }
            });
        }); };
        this.showAuditTrail = function (projectStore) {
            _this.projectAuditInspector.inspect(projectStore);
        };
        this.getPreviewUrl = function (projectStore) {
            return _this.projectService.getPreviewLink(projectStore);
        };
        this.preview = function (projectStore, event) {
            return _this.projectService.preview(projectStore, event);
        };
        this.clone = function (projectStore, origin) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectService.clone(projectStore, origin)];
                    case 1: return [2, _a.sent()];
                }
            });
        }); };
        this.createBlueprint = function (projectStore) {
            return _this.projectService.createBluePrint(projectStore, _this.viewBluePrintChildren);
        };
        this.createPDF = function (projectStore) {
            return _this.projectService.exportToPDF(projectStore);
        };
        this.openTagger = function (projectStore) {
            _this.telemetry.track(Telemetry_1.TelemetryEventName.ProjectTagsViewed, {}, { blockIntercom: true });
            return _this.modal.showSimpleModal({
                title: "Manage page tags",
                body: (0, TagModal_1.createTagModal)([projectStore], _this.projectTagDataStore),
            });
        };
        this.changeOwner = function (projectStore) {
            return _this.projectService.showSelectUserModal([projectStore], function (selectedUser) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (projectStore.user === selectedUser._id) {
                                throw new Error("User already owns project");
                            }
                            return [4, projectStore.changeOwner(selectedUser._id)];
                        case 1:
                            _a.sent();
                            this.telemetry.track(Telemetry_1.TelemetryEventName.ProjectOwnerChanged, {}, { blockIntercom: true });
                            return [2];
                    }
                });
            }); });
        };
        this.openTaggerForProjects = function (projectStores) {
            _this.telemetry.track(Telemetry_1.TelemetryEventName.ProjectTagsViewed, {}, { blockIntercom: true });
            return _this.modal.showSimpleModal({
                title: "Manage page tags",
                body: (0, TagModal_1.createTagModal)(projectStores, _this.projectTagDataStore),
            });
        };
        this.changeOwnerForProjects = function (projectStores) {
            if (projectStores.length === 0) {
                return;
            }
            else if (projectStores.length === 1) {
                return _this.changeOwner(projectStores[0]);
            }
            return _this.projectService.showSelectUserModal(projectStores, function (selectedUser) { return __awaiter(_this, void 0, void 0, function () {
                var projectStoresToUpdate;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            projectStoresToUpdate = projectStores.filter(function (projectStore) {
                                return projectStore.user !== selectedUser._id;
                            });
                            if (projectStoresToUpdate.length === 0) {
                                throw new Error("User already owns projects");
                            }
                            return [4, Promise.all(projectStoresToUpdate.map(function (projectStore) {
                                    return projectStore.changeOwner(selectedUser._id);
                                }))];
                        case 1:
                            _a.sent();
                            this.telemetry.track(Telemetry_1.TelemetryEventName.ProjectOwnerChanged, {}, { blockIntercom: true });
                            return [2];
                    }
                });
            }); });
        };
        this.canEditProject = function (projectStore) {
            return _this.permissionsService.isAllowed(projectStore.userAction, "edit");
        };
        this.restoreWithModal = function (deletedProjectStore) { return __awaiter(_this, void 0, Promise, function () {
            var confirmed, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.projectService.confirmRestore(deletedProjectStore)];
                    case 1:
                        confirmed = _a.sent();
                        if (!confirmed) {
                            return [2, false];
                        }
                        return [4, this.projectService.restore(deletedProjectStore)];
                    case 2:
                        response = _a.sent();
                        return [2, response.success];
                }
            });
        }); };
        this.trackDashboardSorted = function (sortBy, sortDirection) {
            var prop = (0, DashboardTelemetry_1.sortByToTelemetryProperty)(sortBy, sortDirection);
            var parameters = {
                projects_dashboard_sorted_by: prop,
            };
            _this.telemetry.track(Telemetry_1.TelemetryEventName.DashboardSorted, parameters, { blockIntercom: true });
        };
        this.triggerNewEditorModal = function () {
            _this.modal.showAcknowledgeModal(NewEditorModal_1.default);
        };
        this.projectTagDataStore = rootDataStore.projectTagDataStore;
        this.openProjectAnalyticsFunction = (0, UseOpenProjectAnalytics_1.getOpenProjectAnalyticsFunction)(usingFeature, goToProjectAction, serverTelemetry, upseller, "dashboard");
    }
    DashboardController.prototype.openMobileSharePopoverModal = function (projectStore) {
        this.rootDataStore.getPermissionsDataStore().getPagePermissions(projectStore._id).fetchData();
        return (0, MobileSharePopoverModal_1.showMobileSharePopoverModal)(this.modal, projectStore, this.usingFeature);
    };
    return DashboardController;
}());
exports.default = DashboardController;
